import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SelectItem } from 'src/app/core/models/responses/select-item';
import { Roles } from 'src/app/core/models/roles';
import { WidgetItem } from 'src/app/models/chart/widget-item';
import { WidgetService } from 'src/app/services/widget.service';

@Component({
  selector: 'app-widget-customizer-modal',
  templateUrl: './widget-customizer-modal.component.html',
  styleUrls: ['./widget-customizer-modal.component.scss']
})
export class WidgetCustomizerModalComponent implements OnInit {
  widgets: SelectItem[];
  hasUserRole: boolean = false;
  constructor(
    private widgetService: WidgetService,
    public activeModal: NgbActiveModal,
    )
    {
    }

  ngOnInit(): void {
    let currentUser = JSON.parse(localStorage.getItem("currentUser"));
    this.hasUserRole = currentUser.roles.includes(Roles.User);
    if(this.hasUserRole){
      console.log("User Role: " + currentUser.roles);
      this.widgetService.getUserWidgets().toPromise().then(res => {
        this.widgets = res.data;
        this.widgetService.widgetsSubject.next(res.data);
      })  
    }
  }

  confirm(){
    this.widgetService.updateUserWidgets(this.widgets).toPromise().then(res => {
      this.widgets = res.data;
      this.widgetService.widgetsSubject.next(res.data);
    });
    this.activeModal.close();
  }

  toggleChecked(checkbox: HTMLInputElement, item: SelectItem) {
    item.selected = !item.selected;
    checkbox.checked = !checkbox.checked;
  }
}
